import {
    NinchatActionType,
    NinchatGetQueueActivityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const getQueueActivity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatGetQueueActivityAction}`,
    async (arg: NinchatActionParams<NinchatGetQueueActivityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatGetQueueActivityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
